import { gql } from '@apollo/client';

export const SIMPLR_EXPERT_FIELDS_FRAGMENT = gql`
  fragment SimplrExpertFields on SimplrExpert {
    id
    objectId: id
    createdAt
    updatedAt
    isAdmin
    isSpecialist
    isActive
    status
    firstName
    lastName
    email
    phone
    isDeleted
    simplrAccountId
    simplrAccountPtr {
      objectId: id
    }
    userId
    userPtr {
      objectId: id
      username
    }
    avatarName
    userPhone
    userPhoneCountryCode
    isExpert
    routingFeatures
    expertType
    rank
    lastNominatedAt
    availability
    blockedFilterTags
    blacklistedBusinesses
    numChatNominated
    numEmailNominated
    numNonChatUnansweredAssigned
    numChatUnansweredAssigned
    chatDisabled
    blacklistedBusinessIds
    blacklistedBusinessIdsForChat
    lastActivityAt
    numChatActiveAssigned
    expertClass
    pastNominatedEmails
    pastNominatedChats
    lastEmailNominatedAt
    lastEmailAssignedAt
    lastChatNominatedAt
    lastChatAssignedAt
    lastActiveChatAt
    chatModeSince
    chatMode
    endChatModeAt
    expertReviewPopupAcknowledged
    availabilitySwitchLockExpiresAt
    expertToggleLockConfirmation
    numReviewedTickets
    partnerProtectorWhitelist
    pastAssignedChats
    pastAssignedEmails
    currentActiveChats
    autoCandidateScore
    locationCountry
    whitelist
  }
`;
